<template>
  <tr v-if="propertyType"
      draggable="true"
      class="property-row"
      :class="classes"
      @dragover="handleDragOver"
      @dragleave="handleDragLeave"
      @dragstart="handleDragStart"
      @dragend="handleDragEnd"
      @drop="handleDrop"
      @dblclick="$router.push( { name: 'propertyTypeEdit', params: { id: propertyType.id } })"
  >
    <td>
      <button class="asd-btn-edit"
              @click="$router.push( { name: 'propertyTypeEdit', params: { id: propertyType.id } })"
      >
        <i class="fas fa-pencil-alt"></i>
      </button>
      <!-- <div v-if="active" class="asd-btn-group"
           role="group"
           aria-label="Basic example"
      >
        <button v-if="active && !isSystemDefined"
                class="asd-btn-delete"
                title="Deaktivovat"
                @click="deactivateProperty"
        >
          <i class="fas fa-power-off"></i>
        </button>

      </div> -->
    </td>
    <td>
      <span v-if="isSystemDefined" class="system-property-label">
        {{ propertyType.name }} (systémový)
      </span>
      <span v-else>
        {{ propertyType.name }}
      </span>
    </td>
    <td>
      <span v-if="propertyType">
        {{ $t(`property-type.types.${propertyType.type}`) }}
      </span>
    </td>
    <td class="badge-list">
      <span v-for="t in systags" :key="t.tag"
            class="badge badge-pill"
            :style="{backgroundColor: t.color}"
      >
        <i v-if="t.icon" class="fas" :class="[`${t.icon}`]"></i>
        {{ t.name }}
      </span>
    </td>
    <td class="badge-list">
      <span v-if="propertyType.defaultProject" class="badge badge-pill badge-info">Projektu</span>
      <span v-if="propertyType.defaultTask" class="badge badge-pill badge-info">Úkolu</span>
      <span v-if="propertyType.defaultResource" class="badge badge-pill badge-info">Zdroje</span>
    </td>
    <td class="badge-list">
      <span v-for="v in visibleTranslated" :key="v" class="badge badge-pill badge-dark">{{ v }}</span>
    </td>
  </tr>
</template>

<script>
import LangFilters from 'CORE/mixins/langFilters'
import PropertyTypeDataMixin from 'CORE/mixins/property-type-data'
import _ from 'lodash'

const VISIBLE_TRANS = {
    tasksTable: 'Tabulce úkolů',
    projectsTable: 'Tabulce projektů',
    resourcesTable: 'Tabulce zdrojů',
}

export default {
    name: 'PropertyTypeRow',
    mixins: [
        LangFilters,
        PropertyTypeDataMixin,
    ],
    props: {
        propertyTypeId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            cssClasses: {
                'drag-over': false,
                'dragged': false,
            },
        }
    },
    computed: {
        isSystemDefined() {
            return _.startsWith(this.propertyType.key, 'system-')
        },
        systags() {
            return _.pickBy(this.$store.getters.systags, function(value, tag) {
                return _.get(this.propertyTypeSettings, `systags.${tag}`, false)
            }.bind(this))
        },
        order() {
            return _.get(this.propertyTypeSettings, `order`, '0')
        },
        visibleTranslated() {
            return _.map(_.get(this.propertyTypeSettings, `visible`, []), v => VISIBLE_TRANS[v])
        },
        active() {
            const activeUntil = _.get(this.propertyType, 'activeUntil', 0)
            if (activeUntil === 0 || activeUntil === null) return true
            return false
        },
        classes() {
            return { ...this.cssClasses, 'disabled': !this.active }
        },
    },
    methods: {
        handleDragOver($event) {
            $event.preventDefault()
            this.cssClasses['drag-over'] = true
        },
        handleDragLeave($event) {
            this.cssClasses['drag-over'] = false
        },
        handleDragStart($event) {
            this.$emit('setDraggedPropertyType', this.propertyType)
            this.cssClasses['dragged'] = true
        },
        handleDragEnd($event) {
            this.cssClasses['dragged'] = false
        },
        handleDrop($event) {
            this.cssClasses['drag-over'] = false
            this.cssClasses['dragged'] = false
            this.$emit('setDroppedPropertyType', this.propertyType)
        },
    },
}
</script>

<style scoped>
.badge-list > .badge {
  margin: 0 5px;
}
.orderArrow {
  cursor: pointer;
}
.orderArrow:hover {
  color: var(--primary);
}
[draggable="true"] {
    user-select: none;
}
.drag-over {
    border-top: 3px solid var(--primary);
}
.dragged {
    filter: grayscale(100%) opacity(20%);
}
.disabled *:not(button) {
  filter: grayscale(100%)
}
.system-property-label {
    color: Chocolate;
    font-weight: bold;
}
</style>
